import {
  DataGridPro,
  GridCellModes,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import React, { useEffect, useState } from "react";
import { APP_VIEW } from "../../constants/constant";
import "./grid.css";
import GridToolbar from "./grid-toolbar";

function DataGrid(props) {
  const [isInEditMode, setIsInEditMode] = useState(props.isInEditMode);
  const [cellModesModel, setCellModesModel] = useState({});
  const apiRef = useGridApiRef();

  const handleEditClick = () => {
    if (!props.isLocked) {
      setIsInEditMode(true);
      const newCellModesModel = {};

      if (!isInEditMode) {
        props.rows.forEach((row) => {
          newCellModesModel[row.rateTypeId] = {
            currentMonthRate: { mode: GridCellModes.Edit },
          };
        });
      } else {
        props.rows.forEach((row) => {
          newCellModesModel[row.rateTypeId] = {
            currentMonthRate: { mode: GridCellModes.View },
          };
        });
      }

      setCellModesModel(newCellModesModel);
    } else {
      props.handleEditModeError("All the data is already Locked !!");
    }
  };

  const handleCancel = () => {
    setIsInEditMode(false);
    const newCellModesModel = {};
    if (isInEditMode) {
      props.rows.forEach((row) => {
        newCellModesModel[row.rateTypeId] = {
          currentMonthRate: {
            mode: GridCellModes.View,
            ignoreModifications: true,
          },
        };
      });
    }
    setCellModesModel(newCellModesModel);
  };

  const handleSave = () => {
    props.handleSaveClick();
    setIsInEditMode(false);
    handleCancel();
  };

  const handleLockClick = () => {
    props.handleLockClick();
  };

  useEffect(() => {}, [isInEditMode]);

  return (
    <div>
      <DataGridPro
        loading={props.isLoaderVisible}
        rows={props.rows}
        columns={props.columns}
        getRowId={props.getRowId}
        apiRef={apiRef}
        cellModesModel={cellModesModel}
        onCellModesModelChange={(newModel) => setCellModesModel(newModel)}
        isCellEditable={(params) => isInEditMode}
        slots={
          props.view === APP_VIEW.BKP
            ? {
                toolbar: GridToolbar,
              }
            : props.view === APP_VIEW.IB_BP
            ? { toolbar: GridToolbar }
            : {}
        }
        slotProps={{
          toolbar: {
            isInEditMode,
            handleSave,
            handleCancel,
            handleEditClick,
            handleLockClick,
            isLocked: props.isLocked,
            editableAndFreezable: props.editableAndFreezable, 
            view: props.view,
          },
        }}
        initialState={
          props.view === APP_VIEW.BKP
            ? {
                sorting: {
                  sortModel: [{ field: "rateTypeId", sort: "asc" }],
                },
              }
            : props.initialState
        }
        disableRowSelectionOnClick
        disableColumnFilter={props.view === APP_VIEW.BKP ? true : false}
        disableColumnSorting={props.view === APP_VIEW.BKP ? true : false}
        sx={{
          "& .MuiDataGrid-columnHeaders": {
            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#fff",
          },
          "& .MuiDataGrid-cell": {
            backgroundColor: "#fff",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
          },
          "& .MuiDataGrid-filler": {
            backgroundColor: "#fff",
          },
          boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
          borderRadius: "8px",
          padding: "4px",
          margin: "20px",
          backgroundColor: "#fff",
        }}
      />
    </div>
  );
}

export default DataGrid;
